import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage, KeyValueStorageInterface } from 'aws-amplify/utils';

import { BTF_DOMAIN, SESSION_COOKIES_TIMEOUT } from '../shared/constants/auth';
import {
  AMPLIFY_COOKIES_KEY_END_ACCES_TOKEN,
  AMPLIFY_COOKIES_KEY_START,
  IS_NOT_LOCAL
} from '../shared/constants/constants';

export const cookieStorage = new CookieStorage({
  domain: String(BTF_DOMAIN),
  secure: IS_NOT_LOCAL,
  path: '/',
  expires: SESSION_COOKIES_TIMEOUT
});

const storeInCookies = (key: string) => {
  return key.startsWith(AMPLIFY_COOKIES_KEY_START) && !key.endsWith(AMPLIFY_COOKIES_KEY_END_ACCES_TOKEN);
};

export const dividedStorage: KeyValueStorageInterface = {
  async getItem(key: string): Promise<string | null> {
    if (storeInCookies(key)) {
      return cookieStorage.getItem(key);
    }
    return sessionStorage.getItem(key);
  },

  async setItem(key: string, value: string): Promise<void> {
    if (storeInCookies(key)) {
      cookieStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, value);
    }
  },

  async removeItem(key: string): Promise<void> {
    if (storeInCookies(key)) {
      cookieStorage.removeItem(key);
    } else {
      sessionStorage.removeItem(key);
    }
  },

  async clear(): Promise<void> {
    cookieStorage.clear();
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith(AMPLIFY_COOKIES_KEY_START)) {
        sessionStorage.removeItem(key);
      }
    });
  }
};

cognitoUserPoolsTokenProvider.setKeyValueStorage(dividedStorage);

export const SRP_AUTH_FLOW = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.VITE_USERPOOL_ID!,
        userPoolClientId: process.env.VITE_USERPOOL_WEBCLIENT_ID!,
        loginWith: {
          oauth: {
            domain: process.env.VITE_USERPOOL_DOMAIN_URL!,
            scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [process.env.VITE_PORTAL_LOGIN_REDIRECT_URL!],
            redirectSignOut: [process.env.VITE_PORTAL_LOGOUT_REDIRECT_URL!],
            responseType: 'code'
          }
        }
      }
    }
  });
};

export const SRP_AUTH_FLOW_NO_OAUTH = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.VITE_USERPOOL_ID!,
        userPoolClientId: process.env.VITE_USERPOOL_WEBCLIENT_ID!
      }
    }
  });
};
